import React, {useCallback} from "react";

import {flex, flexDirection, mb} from "@pg-design/helpers-css";

import {ISearchFilter} from "../../types/ISearchFilters";
import {FilterCheckbox} from "./FilterCheckbox";

interface IProps {
    filter: ISearchFilter<string, string | number>;
    value?: (number | string)[];
    onChange: (name: string, value: (string | number)[]) => void;
}

export const FilterMultiCheckbox = (props: IProps) => {
    const handleOnChange = useCallback(
        (name: string, isChecked: boolean, value: string | number) => {
            const selectedOptionValue = props.filter.filterOptions.find((filterOptions) => filterOptions.value.toString() === value.toString())?.value;
            if (selectedOptionValue !== 0 && !selectedOptionValue) {
                return;
            }

            if (Array.isArray(props.value) && props.value?.findIndex((value) => value.toString() === selectedOptionValue.toString()) !== -1) {
                props.onChange(
                    props.filter.id,
                    props.value.filter((filterSingleValue) => {
                        return filterSingleValue.toString() !== selectedOptionValue.toString();
                    })
                );
            } else if (props.value) {
                props.onChange(props.filter.id, [...props.value, selectedOptionValue]);
            } else {
                props.onChange(props.filter.id, [selectedOptionValue]);
            }
        },
        [props.filter, props.value, props.onChange]
    );

    const isChecked = (filterValue: string | number) =>
        Array.isArray(props.value) && props.value.findIndex((singleValue) => singleValue.toString() === filterValue.toString()) !== -1;

    return (
        <div css={[flex("flex-start", "space-between"), flexDirection("column")]}>
            {props.filter.filterOptions.map((filterOption) => (
                <FilterCheckbox
                    key={filterOption.id}
                    filterId={props.filter.id}
                    filterOption={filterOption}
                    onChange={handleOnChange}
                    isChecked={isChecked(filterOption.value)}
                    css={mb(1)}
                />
            ))}
        </div>
    );
};
import React, {useCallback} from "react";

import {flex, flexDirection, mb} from "@pg-design/helpers-css";

import {ISearchFilter} from "../../types/ISearchFilters";
import {FilterCheckbox} from "./FilterCheckbox";

interface IProps {
    filter: ISearchFilter<string, string | number>;
    value?: (number | string)[];
    onChange: (name: string, value: (string | number)[]) => void;
}

export const FilterMultiCheckbox = (props: IProps) => {
    const handleOnChange = useCallback(
        (name: string, isChecked: boolean, value: string | number) => {
            const selectedOptionValue = props.filter.filterOptions.find((filterOptions) => filterOptions.value.toString() === value.toString())?.value;
            if (selectedOptionValue !== 0 && !selectedOptionValue) {
                return;
            }

            if (Array.isArray(props.value) && props.value?.findIndex((value) => value.toString() === selectedOptionValue.toString()) !== -1) {
                props.onChange(
                    props.filter.id,
                    props.value.filter((filterSingleValue) => {
                        return filterSingleValue.toString() !== selectedOptionValue.toString();
                    })
                );
            } else if (props.value) {
                props.onChange(props.filter.id, [...props.value, selectedOptionValue]);
            } else {
                props.onChange(props.filter.id, [selectedOptionValue]);
            }
        },
        [props.filter, props.value, props.onChange]
    );

    const isChecked = (filterValue: string | number) =>
        Array.isArray(props.value) && props.value.findIndex((singleValue) => singleValue.toString() === filterValue.toString()) !== -1;

    return (
        <div css={[flex("flex-start", "space-between"), flexDirection("column")]}>
            {props.filter.filterOptions.map((filterOption) => (
                <FilterCheckbox
                    key={filterOption.id}
                    filterId={props.filter.id}
                    filterOption={filterOption}
                    onChange={handleOnChange}
                    isChecked={isChecked(filterOption.value)}
                    css={mb(1)}
                />
            ))}
        </div>
    );
};
